import { render } from "./HomeDesktop.vue?vue&type=template&id=7a6f8dd7&scoped=true"
import script from "./HomeDesktop.vue?vue&type=script&lang=js"
export * from "./HomeDesktop.vue?vue&type=script&lang=js"

import "./HomeDesktop.vue?vue&type=style&index=0&id=7a6f8dd7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6f8dd7"]])

export default __exports__